module.exports = [{"title":"Collections","href":"/admin"},{"title":"Analytics","href":"/admin/analytics"},{"title":"Users","href":"/admin/users","privileged":true}]


//////////////////
// WEBPACK FOOTER
// ./src/client/components/admin/layout/navigation/data.json
// module id = 887
// module chunks = 2